import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { dehydrate, QueryClient } from '@tanstack/react-query';

import g from 'src/constants/urls';
import { IArticleByGroupDetail } from 'src/interface';
import wrapper from 'src/redux';

const HeadC = dynamic(() => import('src/components/Head'));
const CookieConsentContainer = dynamic(() => import('src/containers/CookiesConsent'));

const Privacy = (props:any) => {
	return (
		<>
			<HeadC
				title="Cookies Consent"
				description={
					'Hallobumil menggunakan cookie untuk mendukung kebutuhan fungsional website, aplikasi, ' +
					'dan platform kami demi keamanan, kenyamanan, dan pengalaman yang lebih baik.'
				}
			/>
			<CookieConsentContainer {...props}/>
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store: any) => async () => {
	let isError: boolean = false;
	let contentConsent: any = {};

	const queryClient = new QueryClient();
	const uid = g.ENV === 'production' ? 'vx-4zwsRQPWzQAXztvy4g' :'vx-4zwsRQPWzQAXztvy4g';

	try {
		const uri = `${g.API_EVENT}/settings/consent/${uid}`;
		const opts = {
			method: 'GET',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		};
		const dataListConsent = await fetch(uri, opts);
		contentConsent = await dataListConsent.json().then((res) => ({ ...res, status: dataListConsent.status }));
	} catch (err: any) {
		if (err?.status === 400) {
			isError = true;
		} else {
			throw err;
		}
	}

	const article: IArticleByGroupDetail[] =
		store.getState().articleByGroup.articleByCategory?.data?.records;

	if (!article && isError) return { notFound: true };
	return {
		props: {
			dehydratedState: dehydrate(queryClient),
			card: true,
			isWhiteBackground: true,
			JsonLd: {
				organization: true,
				breadcrumbs: true,
			},
			pageHeaderContent: {
				title: 'Cookies Consent',
				breadcrumbs: [],
			},
			contentConsent: contentConsent.data.record || {},
		},
	};
});

export default Privacy;
